<script>
    import Header from "../components/Header.svelte";
    import Button, { Label } from '@smui/button/styled';
    import Textfield from '@smui/textfield/styled';
    import HelperText from '@smui/textfield/helper-text/index';
    import CharacterCounter from '@smui/textfield/character-counter/index';
    import { api_host, domain_code_store } from "../stores.js";
    import { doFetch } from '../utils/Fetching.svelte';
    import { toast } from '@zerodevx/svelte-toast';
    import * as yup from 'yup';
    import { toast_message } from '../utils/toast_message.js';


    let domain_code = '';

    domain_code_store.subscribe(value => {
        domain_code = value;
    });


    let disable_send = false;

    const formSchema = yup.object().shape({
        full_name: yup
            .string()
            .required('Name is Required'),
        email: yup
            .string()
            .required('This Field is Required')
            .email('Invalid email'),
        subject: yup
            .string()
            .required('Subject is Required'),
        message: yup
            .string()
            .required('Message is Required'),
    });    
    
    let field_data = {};
    for (let nk in formSchema.describe().fields){
        field_data[nk] = "";
        field_data[`${nk}_iv`] = false;
        field_data[`${nk}_h`] = "";
    }

    function resetFieldData() {
        for (let nk in formSchema.describe().fields){
            field_data[`${nk}_iv`] = false;
            field_data[`${nk}_h`] = "";
        }
    }

    async function validateForm(){
        resetFieldData();
        let res = true;
        for (let nk in formSchema.describe().fields){
            await formSchema.validateAt(nk, field_data, {
                abortEarly: true  
            }).catch((err) => {
                field_data[`${nk}_iv`] = true;
                field_data[`${nk}_h`] = err.errors[0];
                res = false;
            });
        }
        return res;
    }

    async function validateSingle(nk) {
        const validateAtRes = await formSchema.validateAt(nk, field_data, {
            abortEarly: true  
        }).then(() => {
            field_data[`${nk}_iv`] = false;
            field_data[`${nk}_h`] = '';
        }).catch((err) => {
            field_data[`${nk}_iv`] = true;
            field_data[`${nk}_h`] = err.errors[0];
        });
    }

    async function send_contact_us_email() {
        if(await validateForm()){
            disable_send = true;
            const payload = {
                name: field_data.full_name, 
                email: field_data.email,
                subject: field_data.subject, 
                message: field_data.message
            };

            const res = await doFetch(
                `${api_host}/api/ex/contact_us`,
                'POST',
                payload,
                { 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            disable_send = false;
            if (res.status) {
                toast_message(true, res.msg, 2000);
                field_data = {
                    full_name: '',
                    email: '',
                    subject: '',
                    message: ''
                };
                resetFieldData();
            } else {
                toast_message(false, res.msg || 'Failed sending message', 2000);
            }
        } else {
            toast.push("Please fill out all required fields", {
                duration: 5000,
                // initial: 0,
                // progress: 0,
                dismissable: false,
                theme: {
                    '--toastBackground': '#F56565',
                    '--toastProgressBackground': '#C53030'
                }
            });
        }
    }
</script>


<Header />
<div class="formholder">
    <div class="pagetitle">
        Contact Us
    </div>

    <div class="preformcontent">
    </div>
        
    <div class="ff fullname">
        <Textfield 
            required
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            invalid={field_data.full_name_iv}
            bind:value={field_data.full_name}
            on:input={() => {validateSingle('full_name')}}
            on:blur={() => {validateSingle('full_name')}}
            label="Full Name"
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.full_name_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff email">
        <Textfield 
            required
            type="email"
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            invalid={field_data.email_iv}
            bind:value={field_data.email}
            label="Email"
            on:input={() => {validateSingle('email')}}
            on:blur={() => {validateSingle('email')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.email_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff subject">
        <Textfield 
            required
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            invalid={field_data.subject_iv}
            bind:value={field_data.subject}
            label="Subject"
            on:input={() => {validateSingle('subject')}}
            on:blur={() => {validateSingle('subject')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.subject_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff message">
        <Textfield 
            required
            textarea 
            input$maxlength="1000" 
            style="width: 100%; height: 100%"
            invalid={field_data.message_iv}
            bind:value={field_data.message} 
            label="Message"
            on:input={() => {validateSingle('message')}}
            on:blur={() => {validateSingle('message')}}
        >
            <CharacterCounter slot="internalCounter">0 / 1000</CharacterCounter>
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.message_h}</HelperText>
        </Textfield>
    </div>

    <div class="ff buttonbar">
        <Button
            on:click={() => {send_contact_us_email();}}
            disabled={disable_send}
            variant="raised" 
            class="button-shaped-round"
        >
            Send Now
        </Button>
    </div>
</div>


<style>
    .formholder {
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-areas: "pt pt"
                             "pc pc"
                             "fn em"
                             "sb sb"
                             "ms ms"
                             "bb . ";
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .formholder {
            width: 90%;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-areas: "pt"
                                 "pc"
                                 "fn"
                                 "em"
                                 "sb"
                                 "ms"
                                 "bb";
        }

    }
    .pagetitle {
        grid-area: pt;
        border-bottom: solid 1px #E9E9EC;
        font-size: 3rem;
        font-weight: bold;
    }
    .preformcontent {
        grid-area: pc;
        padding: 10px;
    }
    .fullname {
        grid-area: fn;
    }
    .email {
        grid-area: em;
    }
    .subject {
        grid-area: sb;
    }
    .message {
        grid-area: ms;
        height: 200px;
    }

    .buttonbar {
        grid-area: bb;
        margin-top: 20px;
    }
    /* globals */
    .ff {
        padding: 10px;
    }
</style>